import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useIconProps } from '../useIconProps';

var Error = function Error(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.504a.5.5 0 01.5.5v2.5a.5.5 0 01-1 0v-2.5a.5.5 0 01.5-.5zm.5 4.75a.5.5 0 11-1 0 .5.5 0 011 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.587 3.249a.5.5 0 01.865 0l5.518 9.504a.5.5 0 01-.432.751H2.5a.5.5 0 01-.433-.75l5.519-9.505zm-4.218 9.255l4.65-8.008 4.65 8.008h-9.3z"
  }));
};

Error.displayName = 'Error';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Error.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Error;